import * as React from 'react';
import { Button as Button$1, Wrap, Arrow } from './styles.js';

/**
 * @deprecated Use DefaultButton instead
 */
const Button = ({ type = 'button', loading, onClick = () => { }, style = {}, children, primary, centred, primaryOutline, arrow, disabled, fullWidth, white, small, arrowWhite, }) => (React.createElement(Button$1, { type: type, isLoading: loading, centred: centred, onClick: loading ? () => { } : onClick, fullWidth: fullWidth, disabled: disabled },
    React.createElement(Wrap, { primary: primary, primaryOutline: primaryOutline, centred: centred, isLoading: loading, fullWidth: fullWidth, style: style, white: white, small: small, arrowWhite: arrowWhite, arrow: arrow },
        React.createElement(Arrow, { arrow: arrow, arrowWhite: arrowWhite }),
        children)));

export { Button };
